// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__JV_Ro","slideInFromTop":"Modal_slideInFromTop__uuUOo","icon":"Modal_icon__A0Eec"};